import React from 'react';
import { LANGUAGES } from '../constants/languages';

const Header = ({ lastUpdated, language = 'en', onLanguageChange }) => {
  return (
    <header className="header">
      <h1>WeeklyDefense.com</h1>
      <h2>Summarizes Worldwide Military,WAR and Strategic Affairs</h2>
      {lastUpdated && (
        <p className="last-updated">
          Last Updated: {new Date(lastUpdated).toLocaleString()}
        </p>
      )}
      {onLanguageChange && (
        <select
          className="language-select"
          value={language}
          onChange={e => onLanguageChange(e.target.value)}
          aria-label="Site language"
          title="Translate all article cards"
        >
          {LANGUAGES.map(l => (
            <option key={l.code} value={l.code}>{l.label}</option>
          ))}
        </select>
      )}
    </header>
  );
};

export default Header;